/**
 * @file
 * Standard collections to use anywhere
 */

import {ObjectCollection} from 'simpli-web-sdk'
import {Region} from '@/enums/Region'
import {UF} from '@/enums/UF'
import {UFInitial} from '@/enums/UFInitial'
import {Period} from '@/enums/Period'
import {GroupBy} from '@/enums/GroupBy'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import {DeliverySlaStatus} from '@/enums/DeliverySlaStatus'
import {TipoSistema} from '@/enums/TipoSistema'
import {GroupByNoDefault} from '@/enums/GroupByNoDefault'
import {TipoCarroceria} from '@/enums/TipoCarroceria'
import {DeliveryDriverStatus} from '@/enums/DeliveryDriverStatus'
import {TipoVeiculo} from '@/enums/TipoVeiculo'
import {MarcaVeiculo} from '@/enums/MarcaVeiculo'
import {Transhipment} from '@/enums/Transhipment'
import {DeliveryAuditGeo} from '@/enums/DeliveryAuditGeo'
import {DeliveryAudit} from '@/enums/DeliveryAudit'
import {DeliveryEvent} from '@/enums/DeliveryEvent'

export abstract class ItrackCollection {
  static get allPeriod() {
    return new ObjectCollection(Period, 'enums.Period')
  }
  static get allGroupBy() {
    return new ObjectCollection(GroupBy, 'enums.GroupBy')
  }
  static get allGroupByNoDefault() {
      return new ObjectCollection(GroupByNoDefault, 'enums.GroupByNoDefault')
  }
  static get allEvent() {
    return new ObjectCollection(DeliveryEvent, 'enums.DeliveryEvent')
  }
  static get allAudit() {
    return new ObjectCollection(DeliveryAudit, 'enums.DeliveryAudit')
  }
  static get allAuditGeo() {
    return new ObjectCollection(DeliveryAuditGeo, 'enums.DeliveryAuditGeo')
  }
  static get allTranshipment() {
    return new ObjectCollection(Transhipment, 'enums.Transhipment')
  }
  static get allDriverStatus() {
    return new ObjectCollection(DeliveryDriverStatus, 'enums.DeliveryDriverStatus')
  }
  static get allTipoVeiculo() {
    return new ObjectCollection(TipoVeiculo, 'enums.TipoVeiculo')
  }
  static get allMarcaVeiculo() {
    return new ObjectCollection(MarcaVeiculo, 'enums.MarcaVeiculo')
  }
  static get allTipoCarroceria() {
    return new ObjectCollection(TipoCarroceria, 'enums.TipoCarroceria')
  }
  static get allRegion() {
    return new ObjectCollection(Region, 'enums.Region')
  }
  static get allUF() {
    return new ObjectCollection(UF, 'enums.UF')
  }
  static get allUFInitial() {
    return new ObjectCollection(UFInitial, 'enums.UFInitial')
  }
  static get allSistema() {
      return new ObjectCollection(TipoSistema, 'enums.TipoSistema')
  }
  static get allStatus() {
    return new ObjectCollection(DeliveryStatus, 'enums.DeliveryStatus')
  }
  static get allSlaStatus() {
    return new ObjectCollection(DeliverySlaStatus, 'enums.DeliverySlaStatus')
  }
}

export const availablePeriods: Period[] = [
  Period.HOURLY,
  Period.DAILY,
  Period.MONTHLY,
]

export const availableGroupBys: GroupBy[] = [
  GroupBy.VAZIO,
  GroupBy.ID_CARGA,
  GroupBy.CTE,
]

export const centroOesteUFs: UF[] = [
  UF.DISTRITO_FEDERAL,
  UF.GOIAS,
  UF.MATO_GROSSO,
  UF.MATO_GROSSO_DO_SUL,
]

export const nordesteUFs: UF[] = [
  UF.ALAGOAS,
  UF.BAHIA,
  UF.CEARA,
  UF.MARANHAO,
  UF.PARAIBA,
  UF.PERNAMBUCO,
  UF.PIAUI,
  UF.RIO_GRANDE_DO_NORTE,
  UF.SERGIPE,
]

export const norteUFs: UF[] = [
  UF.ACRE,
  UF.AMAPA,
  UF.AMAZONAS,
  UF.PARA,
  UF.RONDONIA,
  UF.RORAIMA,
  UF.TOCANTINS,
]

export const sudesteUFs: UF[] = [
  UF.ESPIRITO_SANTO,
  UF.MINAS_GERAIS,
  UF.RIO_DE_JANEIRO,
  UF.SAO_PAULO,
]

export const sulUFs: UF[] = [
  UF.PARANA,
  UF.RIO_GRANDE_DO_SUL,
  UF.SANTA_CATARINA,
]
